module.exports = __webpack_public_path__ + "bg.svg?44d83f951206160867dedeb992217279";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/bg.svg
// module id = 1253
// module chunks = 0